/**
 * Shared URL-safety guard for the affiliates area: whether a value is an absolute
 * http(s) URL we can safely navigate to / open in a new tab. Rejects `javascript:`,
 * `data:`, relative, and malformed URLs. Used both for the campaign URL open button
 * and for the console SSO navigation (the login_url comes from an external upstream,
 * so it is validated before we hand the browser a scheme to execute).
 */
export const isOpenableHttpUrl = (value: string | undefined | null): boolean => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!/^https?:\/\//i.test(trimmed)) return false;
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};
